/* ctr-content-tabs — tab switching + FAQ accordion. No dependencies. */
(function () {
  'use strict';

  function initSection(root) {
    if (root.dataset.ctrCtInit) return;
    root.dataset.ctrCtInit = 'true';

    var tabs = root.querySelectorAll('[data-ctr-tab]');
    var panels = root.querySelectorAll('[data-ctr-panel]');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.dataset.ctrTab;
        tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
        panels.forEach(function (p) { p.classList.toggle('is-active', p.dataset.ctrPanel === key); });
      });
    });

    root.querySelectorAll('.ctr-content-tabs__faq-question').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.closest('.ctr-content-tabs__faq-item').classList.toggle('is-open');
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.ctr-content-tabs').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
